import { Popper } from '@material-ui/core';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import React, { useRef, useState } from 'react';

export const tooltipWrapper = {
  width: '288px',
  height: '586px',
  backgroundColor: 'white',
  borderRadius: '16px',
  padding: '10px',
  marginRight: '12px',
  marginTop: '12px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
  fontFamily: 'Archivo'
};

const AboutDarkModeTooltip = () => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <>
      <HelpOutlineOutlinedIcon
        ref={anchorRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        placement="bottom-start"
      >
        <div style={tooltipWrapper}>
          <img
            src={require('src/images/ABOUT_DARKMODE.webp')}
            alt="about_darkmode_explain"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>
      </Popper>
    </>
  );
};
export default AboutDarkModeTooltip;
